export const webInquiryConstants = {
  SEND_WEB_INQUIRY_REQUEST: "WEB_INQUIRY_SEND_REQUEST",
  SEND_WEB_INQUIRY_SUCCESS: "WEB_INQUIRY_SEND_SUCCESS",
  SEND_WEB_INQUIRY_FAILURE: "WEB_INQUIRY_SEND_FAILURE"
};
